import { render, staticRenderFns } from "./AccountTemplatesTable.vue?vue&type=template&id=933905ec&scoped=true"
import script from "./AccountTemplatesTable.vue?vue&type=script&lang=js"
export * from "./AccountTemplatesTable.vue?vue&type=script&lang=js"
import style0 from "./AccountTemplatesTable.vue?vue&type=style&index=0&id=933905ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933905ec",
  null
  
)

export default component.exports